import { useEffect } from 'react';

const MatomoTrackAppUserDimension = () => {
  useEffect(() => {
    const sendEventData = (isAppUser) => {
      if (window?._paq) {
        window._paq.push(
          ['setCustomDimension', 2, isAppUser]
        );
      }
    };

    if (
      typeof window !== 'undefined' &&
      window?.navigator?.userAgent.includes('1177-appen')
    ) {
      sendEventData('true');
    } else if(typeof window !== 'undefined') 
    {
      sendEventData('false');
    }
  }, []);
  return null;
};

export default MatomoTrackAppUserDimension;